export const STATUS = Object.freeze({
  Active: "Active",
  Inactive: "Inactive"
})
